!function webpackUniversalModuleDefinition(t, e) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = e(require("react"), require("@driftt/tide-core"), require("react-dom"));else if ("function" === typeof define && define.amd) define(["react", "@driftt/tide-core", "react-dom"], e);else {
    var n = "object" === typeof exports ? e(require("react"), require("@driftt/tide-core"), require("react-dom")) : e(t.react, t["@driftt/tide-core"], t["react-dom"]);
    for (var o in n) {
      ("object" === typeof exports ? exports : t)[o] = n[o];
    }
  }
}(window, function (t, e, n) {
  return function (t) {
    var e = {};
    function __webpack_require__(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, __webpack_require__), o.l = !0, o.exports;
    }
    return __webpack_require__.m = t, __webpack_require__.c = e, __webpack_require__.d = function (t, e, n) {
      __webpack_require__.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, __webpack_require__.r = function (t) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (t, e) {
      if (1 & e && (t = __webpack_require__(t)), 8 & e) return t;
      if (4 & e && "object" === typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        __webpack_require__.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, __webpack_require__.n = function (t) {
      var e = t && t.__esModule ? function getDefault() {
        return t.default;
      } : function getModuleExports() {
        return t;
      };
      return __webpack_require__.d(e, "a", e), e;
    }, __webpack_require__.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, __webpack_require__.p = "/driftt/tide/", __webpack_require__(__webpack_require__.s = 7);
  }([function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    var o;
    !function () {
      "use strict";

      var n = {}.hasOwnProperty;
      function classNames() {
        for (var t = [], e = 0; e < arguments.length; e++) {
          var o = arguments[e];
          if (o) {
            var r = typeof o;
            if ("string" === r || "number" === r) t.push(o);else if (Array.isArray(o) && o.length) {
              var i = classNames.apply(null, o);
              i && t.push(i);
            } else if ("object" === r) for (var a in o) {
              n.call(o, a) && o[a] && t.push(a);
            }
          }
        }
        return t.join(" ");
      }
      t.exports ? (classNames.default = classNames, t.exports = classNames) : void 0 === (o = function () {
        return classNames;
      }.apply(e, [])) || (t.exports = o);
    }();
  }, function (t, e, n) {
    t.exports = n(8);
  }, function (t, n) {
    t.exports = e;
  }, function (t, e) {
    t.exports = function (t) {
      var e = [];
      return e.toString = function toString() {
        return this.map(function (e) {
          var n = function cssWithMappingToString(t, e) {
            var n = t[1] || "",
              o = t[3];
            if (!o) return n;
            if (e && "function" === typeof btoa) {
              var r = function toComment(t) {
                  return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(t)))) + " */";
                }(o),
                i = o.sources.map(function (t) {
                  return "/*# sourceURL=" + o.sourceRoot + t + " */";
                });
              return [n].concat(i).concat([r]).join("\n");
            }
            return [n].join("\n");
          }(e, t);
          return e[2] ? "@media " + e[2] + "{" + n + "}" : n;
        }).join("");
      }, e.i = function (t, n) {
        "string" === typeof t && (t = [[null, t, ""]]);
        for (var o = {}, r = 0; r < this.length; r++) {
          var i = this[r][0];
          "number" === typeof i && (o[i] = !0);
        }
        for (r = 0; r < t.length; r++) {
          var a = t[r];
          "number" === typeof a[0] && o[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), e.push(a));
        }
      }, e;
    };
  }, function (t, e, n) {
    var o = {},
      r = function (t) {
        var e;
        return function () {
          return "undefined" === typeof e && (e = t.apply(this, arguments)), e;
        };
      }(function () {
        return window && document && document.all && !window.atob;
      }),
      i = function (t) {
        var e = {};
        return function (t, n) {
          if ("function" === typeof t) return t();
          if ("undefined" === typeof e[t]) {
            var o = function (t, e) {
              return e ? e.querySelector(t) : document.querySelector(t);
            }.call(this, t, n);
            if (window.HTMLIFrameElement && o instanceof window.HTMLIFrameElement) try {
              o = o.contentDocument.head;
            } catch (r) {
              o = null;
            }
            e[t] = o;
          }
          return e[t];
        };
      }(),
      a = null,
      s = 0,
      l = [],
      c = n(18);
    function addStylesToDom(t, e) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n],
          i = o[r.id];
        if (i) {
          i.refs++;
          for (var a = 0; a < i.parts.length; a++) {
            i.parts[a](r.parts[a]);
          }
          for (; a < r.parts.length; a++) {
            i.parts.push(addStyle(r.parts[a], e));
          }
        } else {
          var s = [];
          for (a = 0; a < r.parts.length; a++) {
            s.push(addStyle(r.parts[a], e));
          }
          o[r.id] = {
            id: r.id,
            refs: 1,
            parts: s
          };
        }
      }
    }
    function listToStyles(t, e) {
      for (var n = [], o = {}, r = 0; r < t.length; r++) {
        var i = t[r],
          a = e.base ? i[0] + e.base : i[0],
          s = {
            css: i[1],
            media: i[2],
            sourceMap: i[3]
          };
        o[a] ? o[a].parts.push(s) : n.push(o[a] = {
          id: a,
          parts: [s]
        });
      }
      return n;
    }
    function insertStyleElement(t, e) {
      var n = i(t.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var o = l[l.length - 1];
      if ("top" === t.insertAt) o ? o.nextSibling ? n.insertBefore(e, o.nextSibling) : n.appendChild(e) : n.insertBefore(e, n.firstChild), l.push(e);else if ("bottom" === t.insertAt) n.appendChild(e);else {
        if ("object" !== typeof t.insertAt || !t.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var r = i(t.insertAt.before, n);
        n.insertBefore(e, r);
      }
    }
    function removeStyleElement(t) {
      if (null === t.parentNode) return !1;
      t.parentNode.removeChild(t);
      var e = l.indexOf(t);
      e >= 0 && l.splice(e, 1);
    }
    function createStyleElement(t) {
      var e = document.createElement("style");
      if (void 0 === t.attrs.type && (t.attrs.type = "text/css"), void 0 === t.attrs.nonce) {
        var o = function getNonce() {
          0;
          return n.nc;
        }();
        o && (t.attrs.nonce = o);
      }
      return addAttrs(e, t.attrs), insertStyleElement(t, e), e;
    }
    function addAttrs(t, e) {
      Object.keys(e).forEach(function (n) {
        t.setAttribute(n, e[n]);
      });
    }
    function addStyle(t, e) {
      var n, o, r, i;
      if (e.transform && t.css) {
        if (!(i = e.transform(t.css))) return function () {};
        t.css = i;
      }
      if (e.singleton) {
        var l = s++;
        n = a || (a = createStyleElement(e)), o = applyToSingletonTag.bind(null, n, l, !1), r = applyToSingletonTag.bind(null, n, l, !0);
      } else t.sourceMap && "function" === typeof URL && "function" === typeof URL.createObjectURL && "function" === typeof URL.revokeObjectURL && "function" === typeof Blob && "function" === typeof btoa ? (n = function createLinkElement(t) {
        var e = document.createElement("link");
        return void 0 === t.attrs.type && (t.attrs.type = "text/css"), t.attrs.rel = "stylesheet", addAttrs(e, t.attrs), insertStyleElement(t, e), e;
      }(e), o = function updateLink(t, e, n) {
        var o = n.css,
          r = n.sourceMap,
          i = void 0 === e.convertToAbsoluteUrls && r;
        (e.convertToAbsoluteUrls || i) && (o = c(o));
        r && (o += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */");
        var a = new Blob([o], {
            type: "text/css"
          }),
          s = t.href;
        t.href = URL.createObjectURL(a), s && URL.revokeObjectURL(s);
      }.bind(null, n, e), r = function r() {
        removeStyleElement(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = createStyleElement(e), o = function applyToTag(t, e) {
        var n = e.css,
          o = e.media;
        o && t.setAttribute("media", o);
        if (t.styleSheet) t.styleSheet.cssText = n;else {
          for (; t.firstChild;) {
            t.removeChild(t.firstChild);
          }
          t.appendChild(document.createTextNode(n));
        }
      }.bind(null, n), r = function r() {
        removeStyleElement(n);
      });
      return o(t), function updateStyle(e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
          o(t = e);
        } else r();
      };
    }
    t.exports = function (t, e) {
      if ("undefined" !== typeof DEBUG && DEBUG && "object" !== typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (e = e || {}).attrs = "object" === typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" === typeof e.singleton || (e.singleton = r()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
      var n = listToStyles(t, e);
      return addStylesToDom(n, e), function update(t) {
        for (var r = [], i = 0; i < n.length; i++) {
          var a = n[i];
          (s = o[a.id]).refs--, r.push(s);
        }
        t && addStylesToDom(listToStyles(t, e), e);
        for (i = 0; i < r.length; i++) {
          var s;
          if (0 === (s = r[i]).refs) {
            for (var l = 0; l < s.parts.length; l++) {
              s.parts[l]();
            }
            delete o[s.id];
          }
        }
      };
    };
    var p = function () {
      var t = [];
      return function (e, n) {
        return t[e] = n, t.filter(Boolean).join("\n");
      };
    }();
    function applyToSingletonTag(t, e, n, o) {
      var r = n ? "" : o.css;
      if (t.styleSheet) t.styleSheet.cssText = p(e, r);else {
        var i = document.createTextNode(r),
          a = t.childNodes;
        a[e] && t.removeChild(a[e]), a.length ? t.insertBefore(i, a[e]) : t.appendChild(i);
      }
    }
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function get() {
        return o.default;
      }
    });
    var o = function _interopRequireDefault(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(10));
  }, function (t, e, n) {
    t.exports = n(21);
  }, function (t, e, n) {
    var o = function () {
        return this || "object" === typeof self && self;
      }() || Function("return this")(),
      r = o.regeneratorRuntime && Object.getOwnPropertyNames(o).indexOf("regeneratorRuntime") >= 0,
      i = r && o.regeneratorRuntime;
    if (o.regeneratorRuntime = void 0, t.exports = n(9), r) o.regeneratorRuntime = i;else try {
      delete o.regeneratorRuntime;
    } catch (a) {
      o.regeneratorRuntime = void 0;
    }
  }, function (t, e) {
    !function (e) {
      "use strict";

      var n,
        o = Object.prototype,
        r = o.hasOwnProperty,
        i = "function" === typeof Symbol ? Symbol : {},
        a = i.iterator || "@@iterator",
        s = i.asyncIterator || "@@asyncIterator",
        l = i.toStringTag || "@@toStringTag",
        c = "object" === typeof t,
        p = e.regeneratorRuntime;
      if (p) c && (t.exports = p);else {
        (p = e.regeneratorRuntime = c ? t.exports : {}).wrap = wrap;
        var f = "suspendedStart",
          d = "suspendedYield",
          u = "executing",
          h = "completed",
          m = {},
          g = {};
        g[a] = function () {
          return this;
        };
        var y = Object.getPrototypeOf,
          v = y && y(y(values([])));
        v && v !== o && r.call(v, a) && (g = v);
        var b = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(g);
        GeneratorFunction.prototype = b.constructor = GeneratorFunctionPrototype, GeneratorFunctionPrototype.constructor = GeneratorFunction, GeneratorFunctionPrototype[l] = GeneratorFunction.displayName = "GeneratorFunction", p.isGeneratorFunction = function (t) {
          var e = "function" === typeof t && t.constructor;
          return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
        }, p.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, l in t || (t[l] = "GeneratorFunction")), t.prototype = Object.create(b), t;
        }, p.awrap = function (t) {
          return {
            __await: t
          };
        }, defineIteratorMethods(AsyncIterator.prototype), AsyncIterator.prototype[s] = function () {
          return this;
        }, p.AsyncIterator = AsyncIterator, p.async = function (t, e, n, o) {
          var r = new AsyncIterator(wrap(t, e, n, o));
          return p.isGeneratorFunction(e) ? r : r.next().then(function (t) {
            return t.done ? t.value : r.next();
          });
        }, defineIteratorMethods(b), b[l] = "Generator", b[a] = function () {
          return this;
        }, b.toString = function () {
          return "[object Generator]";
        }, p.keys = function (t) {
          var e = [];
          for (var n in t) {
            e.push(n);
          }
          return e.reverse(), function next() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return next.value = n, next.done = !1, next;
            }
            return next.done = !0, next;
          };
        }, p.values = values, Context.prototype = {
          constructor: Context,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = n, this.done = !1, this.delegate = null, this.method = "next", this.arg = n, this.tryEntries.forEach(resetTryEntry), !t) for (var e in this) {
              "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = n);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;
            function handle(o, r) {
              return a.type = "throw", a.arg = t, e.next = o, r && (e.method = "next", e.arg = n), !!r;
            }
            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                a = i.completion;
              if ("root" === i.tryLoc) return handle("end");
              if (i.tryLoc <= this.prev) {
                var s = r.call(i, "catchLoc"),
                  l = r.call(i, "finallyLoc");
                if (s && l) {
                  if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                } else if (s) {
                  if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                } else {
                  if (!l) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var o = this.tryEntries[n];
              if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), m;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var n = this.tryEntries[e];
              if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), resetTryEntry(n), m;
            }
          },
          catch: function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var n = this.tryEntries[e];
              if (n.tryLoc === t) {
                var o = n.completion;
                if ("throw" === o.type) {
                  var r = o.arg;
                  resetTryEntry(n);
                }
                return r;
              }
            }
            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, o) {
            return this.delegate = {
              iterator: values(t),
              resultName: e,
              nextLoc: o
            }, "next" === this.method && (this.arg = n), m;
          }
        };
      }
      function wrap(t, e, n, o) {
        var r = e && e.prototype instanceof Generator ? e : Generator,
          i = Object.create(r.prototype),
          a = new Context(o || []);
        return i._invoke = function makeInvokeMethod(t, e, n) {
          var o = f;
          return function invoke(r, i) {
            if (o === u) throw new Error("Generator is already running");
            if (o === h) {
              if ("throw" === r) throw i;
              return doneResult();
            }
            for (n.method = r, n.arg = i;;) {
              var a = n.delegate;
              if (a) {
                var s = maybeInvokeDelegate(a, n);
                if (s) {
                  if (s === m) continue;
                  return s;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (o === f) throw o = h, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              o = u;
              var l = tryCatch(t, e, n);
              if ("normal" === l.type) {
                if (o = n.done ? h : d, l.arg === m) continue;
                return {
                  value: l.arg,
                  done: n.done
                };
              }
              "throw" === l.type && (o = h, n.method = "throw", n.arg = l.arg);
            }
          };
        }(t, n, a), i;
      }
      function tryCatch(t, e, n) {
        try {
          return {
            type: "normal",
            arg: t.call(e, n)
          };
        } catch (o) {
          return {
            type: "throw",
            arg: o
          };
        }
      }
      function Generator() {}
      function GeneratorFunction() {}
      function GeneratorFunctionPrototype() {}
      function defineIteratorMethods(t) {
        ["next", "throw", "return"].forEach(function (e) {
          t[e] = function (t) {
            return this._invoke(e, t);
          };
        });
      }
      function AsyncIterator(t) {
        var e;
        this._invoke = function enqueue(n, o) {
          function callInvokeWithMethodAndArg() {
            return new Promise(function (e, i) {
              !function invoke(e, n, o, i) {
                var a = tryCatch(t[e], t, n);
                if ("throw" !== a.type) {
                  var s = a.arg,
                    l = s.value;
                  return l && "object" === typeof l && r.call(l, "__await") ? Promise.resolve(l.__await).then(function (t) {
                    invoke("next", t, o, i);
                  }, function (t) {
                    invoke("throw", t, o, i);
                  }) : Promise.resolve(l).then(function (t) {
                    s.value = t, o(s);
                  }, function (t) {
                    return invoke("throw", t, o, i);
                  });
                }
                i(a.arg);
              }(n, o, e, i);
            });
          }
          return e = e ? e.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
      }
      function maybeInvokeDelegate(t, e) {
        var o = t.iterator[e.method];
        if (o === n) {
          if (e.delegate = null, "throw" === e.method) {
            if (t.iterator.return && (e.method = "return", e.arg = n, maybeInvokeDelegate(t, e), "throw" === e.method)) return m;
            e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return m;
        }
        var r = tryCatch(o, t.iterator, e.arg);
        if ("throw" === r.type) return e.method = "throw", e.arg = r.arg, e.delegate = null, m;
        var i = r.arg;
        return i ? i.done ? (e[t.resultName] = i.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = n), e.delegate = null, m) : i : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, m);
      }
      function pushTryEntry(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }
      function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }
      function Context(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(pushTryEntry, this), this.reset(!0);
      }
      function values(t) {
        if (t) {
          var e = t[a];
          if (e) return e.call(t);
          if ("function" === typeof t.next) return t;
          if (!isNaN(t.length)) {
            var o = -1,
              i = function next() {
                for (; ++o < t.length;) {
                  if (r.call(t, o)) return next.value = t[o], next.done = !1, next;
                }
                return next.value = n, next.done = !0, next;
              };
            return i.next = i;
          }
        }
        return {
          next: doneResult
        };
      }
      function doneResult() {
        return {
          value: n,
          done: !0
        };
      }
    }(function () {
      return this || "object" === typeof self && self;
    }() || Function("return this")());
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = n(0),
      r = _interopRequireDefault(n(11)),
      i = _interopRequireDefault(n(14)),
      a = _interopRequireDefault(n(15));
    function _interopRequireDefault(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function _typeof(t) {
      return (_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof(t) {
        return typeof t;
      } : function _typeof(t) {
        return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }
    function _objectWithoutProperties(t, e) {
      if (null == t) return {};
      var n,
        o,
        r = function _objectWithoutPropertiesLoose(t, e) {
          if (null == t) return {};
          var n,
            o,
            r = {},
            i = Object.keys(t);
          for (o = 0; o < i.length; o++) {
            n = i[o], e.indexOf(n) >= 0 || (r[n] = t[n]);
          }
          return r;
        }(t, e);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);
        for (o = 0; o < i.length; o++) {
          n = i[o], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
        }
      }
      return r;
    }
    function _defineProperties(t, e) {
      for (var n = 0; n < e.length; n++) {
        var o = e[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
      }
    }
    function _getPrototypeOf(t) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }
    function _setPrototypeOf(t, e) {
      return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }
    function _assertThisInitialized(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function _defineProperty(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }
    a.default || console.error("It looks like Tether has not been included. Please load this dependency first https://github.com/HubSpot/tether");
    var s = void 0 !== i.default.createPortal,
      l = [r.default.string, r.default.shape({
        appendChild: r.default.func.isRequired
      })],
      c = ["auto auto", "top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right"],
      p = function (t) {
        function TetherComponent(t) {
          var e;
          return function _classCallCheck(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, TetherComponent), e = function _possibleConstructorReturn(t, e) {
            return !e || "object" !== _typeof(e) && "function" !== typeof e ? _assertThisInitialized(t) : e;
          }(this, _getPrototypeOf(TetherComponent).call(this, t)), _defineProperty(_assertThisInitialized(_assertThisInitialized(e)), "_targetNode", null), _defineProperty(_assertThisInitialized(_assertThisInitialized(e)), "_elementParentNode", null), _defineProperty(_assertThisInitialized(_assertThisInitialized(e)), "_tether", null), _defineProperty(_assertThisInitialized(_assertThisInitialized(e)), "_elementComponent", null), _defineProperty(_assertThisInitialized(_assertThisInitialized(e)), "_targetComponent", null), e.updateChildrenComponents(e.props), e;
        }
        return function _inherits(t, e) {
          if ("function" !== typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && _setPrototypeOf(t, e);
        }(TetherComponent, o.Component), function _createClass(t, e, n) {
          return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
        }(TetherComponent, [{
          key: "updateChildrenComponents",
          value: function updateChildrenComponents(t) {
            var e = o.Children.toArray(t.children);
            this._targetComponent = e[0], this._elementComponent = e[1], this._targetComponent && this._elementComponent && this._createContainer();
          }
        }, {
          key: "componentWillUpdate",
          value: function componentWillUpdate(t) {
            this.updateChildrenComponents(t);
          }
        }, {
          key: "componentDidMount",
          value: function componentDidMount() {
            this._update();
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate() {
            this._update();
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this._destroy();
          }
        }, {
          key: "getTetherInstance",
          value: function getTetherInstance() {
            return this._tether;
          }
        }, {
          key: "disable",
          value: function disable() {
            this._tether.disable();
          }
        }, {
          key: "enable",
          value: function enable() {
            this._tether.enable();
          }
        }, {
          key: "on",
          value: function on(t, e, n) {
            this._tether.on(t, e, n);
          }
        }, {
          key: "once",
          value: function once(t, e, n) {
            this._tether.once(t, e, n);
          }
        }, {
          key: "off",
          value: function off(t, e) {
            this._tether.off(t, e);
          }
        }, {
          key: "position",
          value: function position() {
            this._tether.position();
          }
        }, {
          key: "_registerEventListeners",
          value: function _registerEventListeners() {
            var t = this;
            this.on("update", function () {
              for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++) {
                n[o] = arguments[o];
              }
              return t.props.onUpdate && t.props.onUpdate.apply(t, n);
            }), this.on("repositioned", function () {
              for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++) {
                n[o] = arguments[o];
              }
              return t.props.onRepositioned && t.props.onRepositioned.apply(t, n);
            });
          }
        }, {
          key: "_destroy",
          value: function _destroy() {
            this._elementParentNode && (s || i.default.unmountComponentAtNode(this._elementParentNode), this._elementParentNode.parentNode.removeChild(this._elementParentNode)), this._tether && this._tether.destroy(), this._elementParentNode = null, this._tether = null, this._targetNode = null, this._targetComponent = null, this._elementComponent = null;
          }
        }, {
          key: "_createContainer",
          value: function _createContainer() {
            if (!this._elementParentNode) {
              var t = this.props.renderElementTag;
              this._elementParentNode = document.createElement(t), this._renderNode.appendChild(this._elementParentNode);
            }
          }
        }, {
          key: "_update",
          value: function _update() {
            var t = this,
              e = !this._elementComponent || !this._targetComponent;
            e || (this._targetNode = i.default.findDOMNode(this), e = !this._targetNode), e ? this._destroy() : s ? this._updateTether() : i.default.unstable_renderSubtreeIntoContainer(this, this._elementComponent, this._elementParentNode, function () {
              t._elementParentNode && t._updateTether();
            });
          }
        }, {
          key: "_updateTether",
          value: function _updateTether() {
            var t = this.props,
              e = (t.children, t.renderElementTag, t.renderElementTo, t.id),
              n = t.className,
              o = t.style,
              r = _objectWithoutProperties(t, ["children", "renderElementTag", "renderElementTo", "id", "className", "style"]),
              i = function _objectSpread(t) {
                for (var e = 1; e < arguments.length; e++) {
                  var n = null != arguments[e] ? arguments[e] : {},
                    o = Object.keys(n);
                  "function" === typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(n).filter(function (t) {
                    return Object.getOwnPropertyDescriptor(n, t).enumerable;
                  }))), o.forEach(function (e) {
                    _defineProperty(t, e, n[e]);
                  });
                }
                return t;
              }({
                target: this._targetNode,
                element: this._elementParentNode
              }, r),
              s = e || "";
            this._elementParentNode.id !== s && (this._elementParentNode.id = s);
            var l = n || "";
            if (this._elementParentNode.className !== l && (this._elementParentNode.className = l), o) {
              var c = this._elementParentNode.style;
              Object.keys(o).forEach(function (t) {
                c[t] !== o[t] && (c[t] = o[t]);
              });
            }
            this._tether ? this._tether.setOptions(i) : (this._tether = new a.default(i), this._registerEventListeners()), this._tether.position();
          }
        }, {
          key: "render",
          value: function render() {
            return this._targetComponent ? s && this._elementComponent ? [this._targetComponent, i.default.createPortal(this._elementComponent, this._elementParentNode)] : this._targetComponent : null;
          }
        }, {
          key: "_renderNode",
          get: function get() {
            var t = this.props.renderElementTo;
            return "string" === typeof t ? document.querySelector(t) : t || document.body;
          }
        }]), TetherComponent;
      }();
    _defineProperty(p, "propTypes", {
      renderElementTag: r.default.string,
      renderElementTo: r.default.oneOfType(l),
      attachment: r.default.oneOf(c).isRequired,
      targetAttachment: r.default.oneOf(c),
      offset: r.default.string,
      targetOffset: r.default.string,
      targetModifier: r.default.string,
      enabled: r.default.bool,
      classes: r.default.object,
      classPrefix: r.default.string,
      optimizations: r.default.object,
      constraints: r.default.array,
      id: r.default.string,
      className: r.default.string,
      style: r.default.object,
      onUpdate: r.default.func,
      onRepositioned: r.default.func,
      children: function childrenPropType(t, e, n) {
        var r = t.children,
          i = o.Children.count(r);
        return i <= 0 ? new Error("".concat(n, " expects at least one child to use as the target element.")) : i > 2 ? new Error("Only a max of two children allowed in ".concat(n, ".")) : void 0;
      }
    }), _defineProperty(p, "defaultProps", {
      renderElementTag: "div",
      renderElementTo: null
    });
    var f = p;
    e.default = f;
  }, function (t, e, n) {
    t.exports = n(12)();
  }, function (t, e, n) {
    "use strict";

    var o = n(13);
    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction, t.exports = function () {
      function shim(t, e, n, r, i, a) {
        if (a !== o) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }
      function getShim() {
        return shim;
      }
      shim.isRequired = shim;
      var t = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      return t.PropTypes = t, t;
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (t, e) {
    t.exports = n;
  }, function (t, e, n) {
    var o, r, i;
    r = [], void 0 === (i = "function" === typeof (o = function o() {
      "use strict";

      var t = function () {
        function defineProperties(t, e) {
          for (var n = 0; n < e.length; n++) {
            var o = e[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
          }
        }
        return function (t, e, n) {
          return e && defineProperties(t.prototype, e), n && defineProperties(t, n), t;
        };
      }();
      function _classCallCheck(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }
      var e = void 0;
      "undefined" === typeof e && (e = {
        modules: []
      });
      var n = null;
      function getActualBoundingClientRect(t) {
        var e = t.getBoundingClientRect(),
          n = {};
        for (var o in e) {
          n[o] = e[o];
        }
        try {
          if (t.ownerDocument !== document) {
            var r = t.ownerDocument.defaultView.frameElement;
            if (r) {
              var i = getActualBoundingClientRect(r);
              n.top += i.top, n.bottom += i.top, n.left += i.left, n.right += i.left;
            }
          }
        } catch (a) {}
        return n;
      }
      function getScrollParents(t) {
        var e = getComputedStyle(t) || {},
          n = e.position,
          o = [];
        if ("fixed" === n) return [t];
        for (var r = t; (r = r.parentNode) && r && 1 === r.nodeType;) {
          var i = void 0;
          try {
            i = getComputedStyle(r);
          } catch (p) {}
          if ("undefined" === typeof i || null === i) return o.push(r), o;
          var a = i,
            s = a.overflow,
            l = a.overflowX,
            c = a.overflowY;
          /(auto|scroll|overlay)/.test(s + c + l) && ("absolute" !== n || ["relative", "absolute", "fixed"].indexOf(i.position) >= 0) && o.push(r);
        }
        return o.push(t.ownerDocument.body), t.ownerDocument !== document && o.push(t.ownerDocument.defaultView), o;
      }
      var o = function () {
          var t = 0;
          return function () {
            return ++t;
          };
        }(),
        r = {},
        i = function getOrigin() {
          var t = n;
          t && document.body.contains(t) || ((t = document.createElement("div")).setAttribute("data-tether-id", o()), extend(t.style, {
            top: 0,
            left: 0,
            position: "absolute"
          }), document.body.appendChild(t), n = t);
          var e = t.getAttribute("data-tether-id");
          return "undefined" === typeof r[e] && (r[e] = getActualBoundingClientRect(t), l(function () {
            delete r[e];
          })), r[e];
        };
      function removeUtilElements() {
        n && document.body.removeChild(n), n = null;
      }
      function getBounds(t) {
        var e = void 0;
        t === document ? (e = document, t = document.documentElement) : e = t.ownerDocument;
        var n = e.documentElement,
          o = getActualBoundingClientRect(t),
          r = i();
        return o.top -= r.top, o.left -= r.left, "undefined" === typeof o.width && (o.width = document.body.scrollWidth - o.left - o.right), "undefined" === typeof o.height && (o.height = document.body.scrollHeight - o.top - o.bottom), o.top = o.top - n.clientTop, o.left = o.left - n.clientLeft, o.right = e.body.clientWidth - o.width - o.left, o.bottom = e.body.clientHeight - o.height - o.top, o;
      }
      function getOffsetParent(t) {
        return t.offsetParent || document.documentElement;
      }
      var a = null;
      function getScrollBarSize() {
        if (a) return a;
        var t = document.createElement("div");
        t.style.width = "100%", t.style.height = "200px";
        var e = document.createElement("div");
        extend(e.style, {
          position: "absolute",
          top: 0,
          left: 0,
          pointerEvents: "none",
          visibility: "hidden",
          width: "200px",
          height: "150px",
          overflow: "hidden"
        }), e.appendChild(t), document.body.appendChild(e);
        var n = t.offsetWidth;
        e.style.overflow = "scroll";
        var o = t.offsetWidth;
        n === o && (o = e.clientWidth), document.body.removeChild(e);
        var r = n - o;
        return a = {
          width: r,
          height: r
        };
      }
      function extend() {
        var t = arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0],
          e = [];
        return Array.prototype.push.apply(e, arguments), e.slice(1).forEach(function (e) {
          if (e) for (var n in e) {
            ({}).hasOwnProperty.call(e, n) && (t[n] = e[n]);
          }
        }), t;
      }
      function removeClass(t, e) {
        if ("undefined" !== typeof t.classList) e.split(" ").forEach(function (e) {
          e.trim() && t.classList.remove(e);
        });else {
          var n = new RegExp("(^| )" + e.split(" ").join("|") + "( |$)", "gi"),
            o = getClassName(t).replace(n, " ");
          setClassName(t, o);
        }
      }
      function addClass(t, e) {
        if ("undefined" !== typeof t.classList) e.split(" ").forEach(function (e) {
          e.trim() && t.classList.add(e);
        });else {
          removeClass(t, e);
          var n = getClassName(t) + " " + e;
          setClassName(t, n);
        }
      }
      function hasClass(t, e) {
        if ("undefined" !== typeof t.classList) return t.classList.contains(e);
        var n = getClassName(t);
        return new RegExp("(^| )" + e + "( |$)", "gi").test(n);
      }
      function getClassName(t) {
        return t.className instanceof t.ownerDocument.defaultView.SVGAnimatedString ? t.className.baseVal : t.className;
      }
      function setClassName(t, e) {
        t.setAttribute("class", e);
      }
      function updateClasses(t, e, n) {
        n.forEach(function (n) {
          -1 === e.indexOf(n) && hasClass(t, n) && removeClass(t, n);
        }), e.forEach(function (e) {
          hasClass(t, e) || addClass(t, e);
        });
      }
      var s = [],
        l = function defer(t) {
          s.push(t);
        },
        c = function flush() {
          for (var t = void 0; t = s.pop();) {
            t();
          }
        },
        p = function () {
          function Evented() {
            _classCallCheck(this, Evented);
          }
          return t(Evented, [{
            key: "on",
            value: function on(t, e, n) {
              var o = !(arguments.length <= 3 || void 0 === arguments[3]) && arguments[3];
              "undefined" === typeof this.bindings && (this.bindings = {}), "undefined" === typeof this.bindings[t] && (this.bindings[t] = []), this.bindings[t].push({
                handler: e,
                ctx: n,
                once: o
              });
            }
          }, {
            key: "once",
            value: function once(t, e, n) {
              this.on(t, e, n, !0);
            }
          }, {
            key: "off",
            value: function off(t, e) {
              if ("undefined" !== typeof this.bindings && "undefined" !== typeof this.bindings[t]) if ("undefined" === typeof e) delete this.bindings[t];else for (var n = 0; n < this.bindings[t].length;) {
                this.bindings[t][n].handler === e ? this.bindings[t].splice(n, 1) : ++n;
              }
            }
          }, {
            key: "trigger",
            value: function trigger(t) {
              if ("undefined" !== typeof this.bindings && this.bindings[t]) {
                for (var e = 0, n = arguments.length, o = Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++) {
                  o[r - 1] = arguments[r];
                }
                for (; e < this.bindings[t].length;) {
                  var i = this.bindings[t][e],
                    a = i.handler,
                    s = i.ctx,
                    l = i.once,
                    c = s;
                  "undefined" === typeof c && (c = this), a.apply(c, o), l ? this.bindings[t].splice(e, 1) : ++e;
                }
              }
            }
          }]), Evented;
        }();
      e.Utils = {
        getActualBoundingClientRect: getActualBoundingClientRect,
        getScrollParents: getScrollParents,
        getBounds: getBounds,
        getOffsetParent: getOffsetParent,
        extend: extend,
        addClass: addClass,
        removeClass: removeClass,
        hasClass: hasClass,
        updateClasses: updateClasses,
        defer: l,
        flush: c,
        uniqueId: o,
        Evented: p,
        getScrollBarSize: getScrollBarSize,
        removeUtilElements: removeUtilElements
      };
      var f = function f(t, e) {
          if (Array.isArray(t)) return t;
          if (Symbol.iterator in Object(t)) return function sliceIterator(t, e) {
            var n = [],
              o = !0,
              r = !1,
              i = void 0;
            try {
              for (var a, s = t[Symbol.iterator](); !(o = (a = s.next()).done) && (n.push(a.value), !e || n.length !== e); o = !0) {
                ;
              }
            } catch (l) {
              r = !0, i = l;
            } finally {
              try {
                !o && s.return && s.return();
              } finally {
                if (r) throw i;
              }
            }
            return n;
          }(t, e);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        },
        t = function () {
          function defineProperties(t, e) {
            for (var n = 0; n < e.length; n++) {
              var o = e[n];
              o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
            }
          }
          return function (t, e, n) {
            return e && defineProperties(t.prototype, e), n && defineProperties(t, n), t;
          };
        }(),
        d = function get(t, e, n) {
          for (var o = !0; o;) {
            var r = t,
              i = e,
              a = n;
            o = !1, null === r && (r = Function.prototype);
            var s = Object.getOwnPropertyDescriptor(r, i);
            if (void 0 !== s) {
              if ("value" in s) return s.value;
              var l = s.get;
              if (void 0 === l) return;
              return l.call(a);
            }
            var c = Object.getPrototypeOf(r);
            if (null === c) return;
            t = c, e = i, n = a, o = !0, s = c = void 0;
          }
        };
      function _classCallCheck(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }
      if ("undefined" === typeof e) throw new Error("You must include the utils.js file before tether.js");
      var getScrollParents = (T = e.Utils).getScrollParents,
        getBounds = T.getBounds,
        getOffsetParent = T.getOffsetParent,
        extend = T.extend,
        addClass = T.addClass,
        removeClass = T.removeClass,
        updateClasses = T.updateClasses,
        l = T.defer,
        c = T.flush,
        getScrollBarSize = T.getScrollBarSize,
        removeUtilElements = T.removeUtilElements;
      function within(t, e) {
        var n = arguments.length <= 2 || void 0 === arguments[2] ? 1 : arguments[2];
        return t + n >= e && e >= t - n;
      }
      var u = function () {
          if ("undefined" === typeof document) return "";
          for (var t = document.createElement("div"), e = ["transform", "WebkitTransform", "OTransform", "MozTransform", "msTransform"], n = 0; n < e.length; ++n) {
            var o = e[n];
            if (void 0 !== t.style[o]) return o;
          }
        }(),
        h = [],
        m = function position() {
          h.forEach(function (t) {
            t.position(!1);
          }), c();
        };
      function now() {
        return "object" === typeof performance && "function" === typeof performance.now ? performance.now() : +new Date();
      }
      !function () {
        var t = null,
          e = null,
          n = null,
          o = function tick() {
            if ("undefined" !== typeof e && e > 16) return e = Math.min(e - 16, 250), void (n = setTimeout(tick, 250));
            "undefined" !== typeof t && now() - t < 10 || (null != n && (clearTimeout(n), n = null), t = now(), m(), e = now() - t);
          };
        "undefined" !== typeof window && "undefined" !== typeof window.addEventListener && ["resize", "scroll", "touchmove"].forEach(function (t) {
          window.addEventListener(t, o);
        });
      }();
      var g = {
          center: "center",
          left: "right",
          right: "left"
        },
        y = {
          middle: "middle",
          top: "bottom",
          bottom: "top"
        },
        v = {
          top: 0,
          left: 0,
          middle: "50%",
          center: "50%",
          bottom: "100%",
          right: "100%"
        },
        b = function attachmentToOffset(t) {
          var e = t.left,
            n = t.top;
          return "undefined" !== typeof v[t.left] && (e = v[t.left]), "undefined" !== typeof v[t.top] && (n = v[t.top]), {
            left: e,
            top: n
          };
        };
      function addOffset() {
        for (var t = {
            top: 0,
            left: 0
          }, e = arguments.length, n = Array(e), o = 0; o < e; o++) {
          n[o] = arguments[o];
        }
        return n.forEach(function (e) {
          var n = e.top,
            o = e.left;
          "string" === typeof n && (n = parseFloat(n, 10)), "string" === typeof o && (o = parseFloat(o, 10)), t.top += n, t.left += o;
        }), t;
      }
      function offsetToPx(t, e) {
        return "string" === typeof t.left && -1 !== t.left.indexOf("%") && (t.left = parseFloat(t.left, 10) / 100 * e.width), "string" === typeof t.top && -1 !== t.top.indexOf("%") && (t.top = parseFloat(t.top, 10) / 100 * e.height), t;
      }
      var _ = function parseOffset(t) {
          var e = t.split(" "),
            n = f(e, 2),
            o = n[0],
            r = n[1];
          return {
            top: o,
            left: r
          };
        },
        w = _,
        x = function (n) {
          function TetherClass(t) {
            var n = this;
            _classCallCheck(this, TetherClass), d(Object.getPrototypeOf(TetherClass.prototype), "constructor", this).call(this), this.position = this.position.bind(this), h.push(this), this.history = [], this.setOptions(t, !1), e.modules.forEach(function (t) {
              "undefined" !== typeof t.initialize && t.initialize.call(n);
            }), this.position();
          }
          return function _inherits(t, e) {
            if ("function" !== typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
            t.prototype = Object.create(e && e.prototype, {
              constructor: {
                value: t,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
          }(TetherClass, n), t(TetherClass, [{
            key: "getClass",
            value: function getClass() {
              var t = arguments.length <= 0 || void 0 === arguments[0] ? "" : arguments[0],
                e = this.options.classes;
              return "undefined" !== typeof e && e[t] ? this.options.classes[t] : this.options.classPrefix ? this.options.classPrefix + "-" + t : t;
            }
          }, {
            key: "setOptions",
            value: function setOptions(t) {
              var e = this,
                n = arguments.length <= 1 || void 0 === arguments[1] || arguments[1];
              this.options = extend({
                offset: "0 0",
                targetOffset: "0 0",
                targetAttachment: "auto auto",
                classPrefix: "tether"
              }, t);
              var o = this.options,
                r = o.element,
                i = o.target,
                a = o.targetModifier;
              if (this.element = r, this.target = i, this.targetModifier = a, "viewport" === this.target ? (this.target = document.body, this.targetModifier = "visible") : "scroll-handle" === this.target && (this.target = document.body, this.targetModifier = "scroll-handle"), ["element", "target"].forEach(function (t) {
                if ("undefined" === typeof e[t]) throw new Error("Tether Error: Both element and target must be defined");
                "undefined" !== typeof e[t].jquery ? e[t] = e[t][0] : "string" === typeof e[t] && (e[t] = document.querySelector(e[t]));
              }), addClass(this.element, this.getClass("element")), !1 !== this.options.addTargetClasses && addClass(this.target, this.getClass("target")), !this.options.attachment) throw new Error("Tether Error: You must provide an attachment");
              this.targetAttachment = w(this.options.targetAttachment), this.attachment = w(this.options.attachment), this.offset = _(this.options.offset), this.targetOffset = _(this.options.targetOffset), "undefined" !== typeof this.scrollParents && this.disable(), "scroll-handle" === this.targetModifier ? this.scrollParents = [this.target] : this.scrollParents = getScrollParents(this.target), !1 !== this.options.enabled && this.enable(n);
            }
          }, {
            key: "getTargetBounds",
            value: function getTargetBounds() {
              if ("undefined" === typeof this.targetModifier) return getBounds(this.target);
              if ("visible" === this.targetModifier) {
                if (this.target === document.body) return {
                  top: pageYOffset,
                  left: pageXOffset,
                  height: innerHeight,
                  width: innerWidth
                };
                var t = getBounds(this.target),
                  e = {
                    height: t.height,
                    width: t.width,
                    top: t.top,
                    left: t.left
                  };
                return e.height = Math.min(e.height, t.height - (pageYOffset - t.top)), e.height = Math.min(e.height, t.height - (t.top + t.height - (pageYOffset + innerHeight))), e.height = Math.min(innerHeight, e.height), e.height -= 2, e.width = Math.min(e.width, t.width - (pageXOffset - t.left)), e.width = Math.min(e.width, t.width - (t.left + t.width - (pageXOffset + innerWidth))), e.width = Math.min(innerWidth, e.width), e.width -= 2, e.top < pageYOffset && (e.top = pageYOffset), e.left < pageXOffset && (e.left = pageXOffset), e;
              }
              if ("scroll-handle" === this.targetModifier) {
                var t = void 0,
                  n = this.target;
                n === document.body ? (n = document.documentElement, t = {
                  left: pageXOffset,
                  top: pageYOffset,
                  height: innerHeight,
                  width: innerWidth
                }) : t = getBounds(n);
                var o = getComputedStyle(n),
                  r = n.scrollWidth > n.clientWidth || [o.overflow, o.overflowX].indexOf("scroll") >= 0 || this.target !== document.body,
                  i = 0;
                r && (i = 15);
                var a = t.height - parseFloat(o.borderTopWidth) - parseFloat(o.borderBottomWidth) - i,
                  e = {
                    width: 15,
                    height: .975 * a * (a / n.scrollHeight),
                    left: t.left + t.width - parseFloat(o.borderLeftWidth) - 15
                  },
                  s = 0;
                a < 408 && this.target === document.body && (s = -11e-5 * Math.pow(a, 2) - .00727 * a + 22.58), this.target !== document.body && (e.height = Math.max(e.height, 24));
                var l = this.target.scrollTop / (n.scrollHeight - a);
                return e.top = l * (a - e.height - s) + t.top + parseFloat(o.borderTopWidth), this.target === document.body && (e.height = Math.max(e.height, 24)), e;
              }
            }
          }, {
            key: "clearCache",
            value: function clearCache() {
              this._cache = {};
            }
          }, {
            key: "cache",
            value: function cache(t, e) {
              return "undefined" === typeof this._cache && (this._cache = {}), "undefined" === typeof this._cache[t] && (this._cache[t] = e.call(this)), this._cache[t];
            }
          }, {
            key: "enable",
            value: function enable() {
              var t = this,
                e = arguments.length <= 0 || void 0 === arguments[0] || arguments[0];
              !1 !== this.options.addTargetClasses && addClass(this.target, this.getClass("enabled")), addClass(this.element, this.getClass("enabled")), this.enabled = !0, this.scrollParents.forEach(function (e) {
                e !== t.target.ownerDocument && e.addEventListener("scroll", t.position);
              }), e && this.position();
            }
          }, {
            key: "disable",
            value: function disable() {
              var t = this;
              removeClass(this.target, this.getClass("enabled")), removeClass(this.element, this.getClass("enabled")), this.enabled = !1, "undefined" !== typeof this.scrollParents && this.scrollParents.forEach(function (e) {
                e.removeEventListener("scroll", t.position);
              });
            }
          }, {
            key: "destroy",
            value: function destroy() {
              var t = this;
              this.disable(), h.forEach(function (e, n) {
                e === t && h.splice(n, 1);
              }), 0 === h.length && removeUtilElements();
            }
          }, {
            key: "updateAttachClasses",
            value: function updateAttachClasses(t, e) {
              var n = this;
              t = t || this.attachment, e = e || this.targetAttachment, "undefined" !== typeof this._addAttachClasses && this._addAttachClasses.length && this._addAttachClasses.splice(0, this._addAttachClasses.length), "undefined" === typeof this._addAttachClasses && (this._addAttachClasses = []);
              var o = this._addAttachClasses;
              t.top && o.push(this.getClass("element-attached") + "-" + t.top), t.left && o.push(this.getClass("element-attached") + "-" + t.left), e.top && o.push(this.getClass("target-attached") + "-" + e.top), e.left && o.push(this.getClass("target-attached") + "-" + e.left);
              var r = [];
              ["left", "top", "bottom", "right", "middle", "center"].forEach(function (t) {
                r.push(n.getClass("element-attached") + "-" + t), r.push(n.getClass("target-attached") + "-" + t);
              }), l(function () {
                "undefined" !== typeof n._addAttachClasses && (updateClasses(n.element, n._addAttachClasses, r), !1 !== n.options.addTargetClasses && updateClasses(n.target, n._addAttachClasses, r), delete n._addAttachClasses);
              });
            }
          }, {
            key: "position",
            value: function position() {
              var t = this,
                n = arguments.length <= 0 || void 0 === arguments[0] || arguments[0];
              if (this.enabled) {
                this.clearCache();
                var o = function autoToFixedAttachment(t, e) {
                  var n = t.left,
                    o = t.top;
                  return "auto" === n && (n = g[e.left]), "auto" === o && (o = y[e.top]), {
                    left: n,
                    top: o
                  };
                }(this.targetAttachment, this.attachment);
                this.updateAttachClasses(this.attachment, o);
                var r = this.cache("element-bounds", function () {
                    return getBounds(t.element);
                  }),
                  i = r.width,
                  a = r.height;
                if (0 === i && 0 === a && "undefined" !== typeof this.lastSize) {
                  var s = this.lastSize;
                  i = s.width, a = s.height;
                } else this.lastSize = {
                  width: i,
                  height: a
                };
                var l = this.cache("target-bounds", function () {
                    return t.getTargetBounds();
                  }),
                  p = l,
                  f = offsetToPx(b(this.attachment), {
                    width: i,
                    height: a
                  }),
                  d = offsetToPx(b(o), p),
                  u = offsetToPx(this.offset, {
                    width: i,
                    height: a
                  }),
                  h = offsetToPx(this.targetOffset, p);
                f = addOffset(f, u), d = addOffset(d, h);
                for (var m = l.left + d.left - f.left, v = l.top + d.top - f.top, _ = 0; _ < e.modules.length; ++_) {
                  var w = e.modules[_],
                    x = w.position.call(this, {
                      left: m,
                      top: v,
                      targetAttachment: o,
                      targetPos: l,
                      elementPos: r,
                      offset: f,
                      targetOffset: d,
                      manualOffset: u,
                      manualTargetOffset: h,
                      scrollbarSize: E,
                      attachment: this.attachment
                    });
                  if (!1 === x) return !1;
                  "undefined" !== typeof x && "object" === typeof x && (v = x.top, m = x.left);
                }
                var C = {
                    page: {
                      top: v,
                      left: m
                    },
                    viewport: {
                      top: v - pageYOffset,
                      bottom: pageYOffset - v - a + innerHeight,
                      left: m - pageXOffset,
                      right: pageXOffset - m - i + innerWidth
                    }
                  },
                  O = this.target.ownerDocument,
                  T = O.defaultView,
                  E = void 0;
                return T.innerHeight > O.documentElement.clientHeight && (E = this.cache("scrollbar-size", getScrollBarSize), C.viewport.bottom -= E.height), T.innerWidth > O.documentElement.clientWidth && (E = this.cache("scrollbar-size", getScrollBarSize), C.viewport.right -= E.width), -1 !== ["", "static"].indexOf(O.body.style.position) && -1 !== ["", "static"].indexOf(O.body.parentElement.style.position) || (C.page.bottom = O.body.scrollHeight - v - a, C.page.right = O.body.scrollWidth - m - i), "undefined" !== typeof this.options.optimizations && !1 !== this.options.optimizations.moveElement && "undefined" === typeof this.targetModifier && function () {
                  var e = t.cache("target-offsetparent", function () {
                      return getOffsetParent(t.target);
                    }),
                    n = t.cache("target-offsetparent-bounds", function () {
                      return getBounds(e);
                    }),
                    o = getComputedStyle(e),
                    r = n,
                    i = {};
                  if (["Top", "Left", "Bottom", "Right"].forEach(function (t) {
                    i[t.toLowerCase()] = parseFloat(o["border" + t + "Width"]);
                  }), n.right = O.body.scrollWidth - n.left - r.width + i.right, n.bottom = O.body.scrollHeight - n.top - r.height + i.bottom, C.page.top >= n.top + i.top && C.page.bottom >= n.bottom && C.page.left >= n.left + i.left && C.page.right >= n.right) {
                    var a = e.scrollTop,
                      s = e.scrollLeft;
                    C.offset = {
                      top: C.page.top - n.top + a - i.top,
                      left: C.page.left - n.left + s - i.left
                    };
                  }
                }(), this.move(C), this.history.unshift(C), this.history.length > 3 && this.history.pop(), n && c(), !0;
              }
            }
          }, {
            key: "move",
            value: function move(t) {
              var e = this;
              if ("undefined" !== typeof this.element.parentNode) {
                var n = {};
                for (var o in t) {
                  for (var r in n[o] = {}, t[o]) {
                    for (var i = !1, a = 0; a < this.history.length; ++a) {
                      var s = this.history[a];
                      if ("undefined" !== typeof s[o] && !within(s[o][r], t[o][r])) {
                        i = !0;
                        break;
                      }
                    }
                    i || (n[o][r] = !0);
                  }
                }
                var c = {
                    top: "",
                    left: "",
                    right: "",
                    bottom: ""
                  },
                  p = function transcribe(t, n) {
                    var o = "undefined" !== typeof e.options.optimizations,
                      r = o ? e.options.optimizations.gpu : null;
                    if (!1 !== r) {
                      var i = void 0,
                        a = void 0;
                      t.top ? (c.top = 0, i = n.top) : (c.bottom = 0, i = -n.bottom), t.left ? (c.left = 0, a = n.left) : (c.right = 0, a = -n.right), "number" === typeof window.devicePixelRatio && devicePixelRatio % 1 === 0 && (a = Math.round(a * devicePixelRatio) / devicePixelRatio, i = Math.round(i * devicePixelRatio) / devicePixelRatio), c[u] = "translateX(" + a + "px) translateY(" + i + "px)", "msTransform" !== u && (c[u] += " translateZ(0)");
                    } else t.top ? c.top = n.top + "px" : c.bottom = n.bottom + "px", t.left ? c.left = n.left + "px" : c.right = n.right + "px";
                  },
                  f = !1;
                if ((n.page.top || n.page.bottom) && (n.page.left || n.page.right) ? (c.position = "absolute", p(n.page, t.page)) : (n.viewport.top || n.viewport.bottom) && (n.viewport.left || n.viewport.right) ? (c.position = "fixed", p(n.viewport, t.viewport)) : "undefined" !== typeof n.offset && n.offset.top && n.offset.left ? function () {
                  c.position = "absolute";
                  var o = e.cache("target-offsetparent", function () {
                    return getOffsetParent(e.target);
                  });
                  getOffsetParent(e.element) !== o && l(function () {
                    e.element.parentNode.removeChild(e.element), o.appendChild(e.element);
                  }), p(n.offset, t.offset), f = !0;
                }() : (c.position = "absolute", p({
                  top: !0,
                  left: !0
                }, t.page)), !f) if (this.options.bodyElement) this.element.parentNode !== this.options.bodyElement && this.options.bodyElement.appendChild(this.element);else {
                  for (var d = function isFullscreenElement(t) {
                      var e = t.ownerDocument,
                        n = e.fullscreenElement || e.webkitFullscreenElement || e.mozFullScreenElement || e.msFullscreenElement;
                      return n === t;
                    }, h = !0, m = this.element.parentNode; m && 1 === m.nodeType && "BODY" !== m.tagName && !d(m);) {
                    if ("static" !== getComputedStyle(m).position) {
                      h = !1;
                      break;
                    }
                    m = m.parentNode;
                  }
                  h || (this.element.parentNode.removeChild(this.element), this.element.ownerDocument.body.appendChild(this.element));
                }
                var g = {},
                  y = !1;
                for (var r in c) {
                  var v = c[r],
                    b = this.element.style[r];
                  b !== v && (y = !0, g[r] = v);
                }
                y && l(function () {
                  extend(e.element.style, g), e.trigger("repositioned");
                });
              }
            }
          }]), TetherClass;
        }(p);
      x.modules = [], e.position = m;
      var C = extend(x, e),
        f = function f(t, e) {
          if (Array.isArray(t)) return t;
          if (Symbol.iterator in Object(t)) return function sliceIterator(t, e) {
            var n = [],
              o = !0,
              r = !1,
              i = void 0;
            try {
              for (var a, s = t[Symbol.iterator](); !(o = (a = s.next()).done) && (n.push(a.value), !e || n.length !== e); o = !0) {
                ;
              }
            } catch (l) {
              r = !0, i = l;
            } finally {
              try {
                !o && s.return && s.return();
              } finally {
                if (r) throw i;
              }
            }
            return n;
          }(t, e);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        },
        getBounds = (T = e.Utils).getBounds,
        extend = T.extend,
        updateClasses = T.updateClasses,
        l = T.defer,
        O = ["left", "top", "right", "bottom"];
      e.modules.push({
        position: function position(t) {
          var e = this,
            n = t.top,
            o = t.left,
            r = t.targetAttachment;
          if (!this.options.constraints) return !0;
          var i = this.cache("element-bounds", function () {
              return getBounds(e.element);
            }),
            a = i.height,
            s = i.width;
          if (0 === s && 0 === a && "undefined" !== typeof this.lastSize) {
            var c = this.lastSize;
            s = c.width, a = c.height;
          }
          var p = this.cache("target-bounds", function () {
              return e.getTargetBounds();
            }),
            d = p.height,
            u = p.width,
            h = [this.getClass("pinned"), this.getClass("out-of-bounds")];
          this.options.constraints.forEach(function (t) {
            var e = t.outOfBoundsClass,
              n = t.pinnedClass;
            e && h.push(e), n && h.push(n);
          }), h.forEach(function (t) {
            ["left", "top", "right", "bottom"].forEach(function (e) {
              h.push(t + "-" + e);
            });
          });
          var m = [],
            g = extend({}, r),
            y = extend({}, this.attachment);
          return this.options.constraints.forEach(function (t) {
            var i = t.to,
              l = t.attachment,
              c = t.pin;
            "undefined" === typeof l && (l = "");
            var p = void 0,
              h = void 0;
            if (l.indexOf(" ") >= 0) {
              var v = l.split(" "),
                b = f(v, 2);
              h = b[0], p = b[1];
            } else p = h = l;
            var _ = function getBoundingRect(t, e) {
              return "scrollParent" === e ? e = t.scrollParents[0] : "window" === e && (e = [pageXOffset, pageYOffset, innerWidth + pageXOffset, innerHeight + pageYOffset]), e === document && (e = e.documentElement), "undefined" !== typeof e.nodeType && function () {
                var t = e,
                  n = getBounds(e),
                  o = n,
                  r = getComputedStyle(e);
                if (e = [o.left, o.top, n.width + o.left, n.height + o.top], t.ownerDocument !== document) {
                  var i = t.ownerDocument.defaultView;
                  e[0] += i.pageXOffset, e[1] += i.pageYOffset, e[2] += i.pageXOffset, e[3] += i.pageYOffset;
                }
                O.forEach(function (t, n) {
                  "Top" === (t = t[0].toUpperCase() + t.substr(1)) || "Left" === t ? e[n] += parseFloat(r["border" + t + "Width"]) : e[n] -= parseFloat(r["border" + t + "Width"]);
                });
              }(), e;
            }(e, i);
            "target" !== h && "both" !== h || (n < _[1] && "top" === g.top && (n += d, g.top = "bottom"), n + a > _[3] && "bottom" === g.top && (n -= d, g.top = "top")), "together" === h && ("top" === g.top && ("bottom" === y.top && n < _[1] ? (n += d, g.top = "bottom", n += a, y.top = "top") : "top" === y.top && n + a > _[3] && n - (a - d) >= _[1] && (n -= a - d, g.top = "bottom", y.top = "bottom")), "bottom" === g.top && ("top" === y.top && n + a > _[3] ? (n -= d, g.top = "top", n -= a, y.top = "bottom") : "bottom" === y.top && n < _[1] && n + (2 * a - d) <= _[3] && (n += a - d, g.top = "top", y.top = "top")), "middle" === g.top && (n + a > _[3] && "top" === y.top ? (n -= a, y.top = "bottom") : n < _[1] && "bottom" === y.top && (n += a, y.top = "top"))), "target" !== p && "both" !== p || (o < _[0] && "left" === g.left && (o += u, g.left = "right"), o + s > _[2] && "right" === g.left && (o -= u, g.left = "left")), "together" === p && (o < _[0] && "left" === g.left ? "right" === y.left ? (o += u, g.left = "right", o += s, y.left = "left") : "left" === y.left && (o += u, g.left = "right", o -= s, y.left = "right") : o + s > _[2] && "right" === g.left ? "left" === y.left ? (o -= u, g.left = "left", o -= s, y.left = "right") : "right" === y.left && (o -= u, g.left = "left", o += s, y.left = "left") : "center" === g.left && (o + s > _[2] && "left" === y.left ? (o -= s, y.left = "right") : o < _[0] && "right" === y.left && (o += s, y.left = "left"))), "element" !== h && "both" !== h || (n < _[1] && "bottom" === y.top && (n += a, y.top = "top"), n + a > _[3] && "top" === y.top && (n -= a, y.top = "bottom")), "element" !== p && "both" !== p || (o < _[0] && ("right" === y.left ? (o += s, y.left = "left") : "center" === y.left && (o += s / 2, y.left = "left")), o + s > _[2] && ("left" === y.left ? (o -= s, y.left = "right") : "center" === y.left && (o -= s / 2, y.left = "right"))), "string" === typeof c ? c = c.split(",").map(function (t) {
              return t.trim();
            }) : !0 === c && (c = ["top", "left", "right", "bottom"]), c = c || [];
            var w = [],
              x = [];
            n < _[1] && (c.indexOf("top") >= 0 ? (n = _[1], w.push("top")) : x.push("top")), n + a > _[3] && (c.indexOf("bottom") >= 0 ? (n = _[3] - a, w.push("bottom")) : x.push("bottom")), o < _[0] && (c.indexOf("left") >= 0 ? (o = _[0], w.push("left")) : x.push("left")), o + s > _[2] && (c.indexOf("right") >= 0 ? (o = _[2] - s, w.push("right")) : x.push("right")), w.length && function () {
              var t = void 0;
              t = "undefined" !== typeof e.options.pinnedClass ? e.options.pinnedClass : e.getClass("pinned"), m.push(t), w.forEach(function (e) {
                m.push(t + "-" + e);
              });
            }(), x.length && function () {
              var t = void 0;
              t = "undefined" !== typeof e.options.outOfBoundsClass ? e.options.outOfBoundsClass : e.getClass("out-of-bounds"), m.push(t), x.forEach(function (e) {
                m.push(t + "-" + e);
              });
            }(), (w.indexOf("left") >= 0 || w.indexOf("right") >= 0) && (y.left = g.left = !1), (w.indexOf("top") >= 0 || w.indexOf("bottom") >= 0) && (y.top = g.top = !1), g.top === r.top && g.left === r.left && y.top === e.attachment.top && y.left === e.attachment.left || (e.updateAttachClasses(y, g), e.trigger("update", {
              attachment: y,
              targetAttachment: g
            }));
          }), l(function () {
            !1 !== e.options.addTargetClasses && updateClasses(e.target, m, h), updateClasses(e.element, m, h);
          }), {
            top: n,
            left: o
          };
        }
      });
      var T,
        getBounds = (T = e.Utils).getBounds,
        updateClasses = T.updateClasses,
        l = T.defer;
      e.modules.push({
        position: function position(t) {
          var e = this,
            n = t.top,
            o = t.left,
            r = this.cache("element-bounds", function () {
              return getBounds(e.element);
            }),
            i = r.height,
            a = r.width,
            s = this.getTargetBounds(),
            c = n + i,
            p = o + a,
            f = [];
          n <= s.bottom && c >= s.top && ["left", "right"].forEach(function (t) {
            var e = s[t];
            e !== o && e !== p || f.push(t);
          }), o <= s.right && p >= s.left && ["top", "bottom"].forEach(function (t) {
            var e = s[t];
            e !== n && e !== c || f.push(t);
          });
          var d = [],
            u = [];
          return d.push(this.getClass("abutted")), ["left", "top", "right", "bottom"].forEach(function (t) {
            d.push(e.getClass("abutted") + "-" + t);
          }), f.length && u.push(this.getClass("abutted")), f.forEach(function (t) {
            u.push(e.getClass("abutted") + "-" + t);
          }), l(function () {
            !1 !== e.options.addTargetClasses && updateClasses(e.target, u, d), updateClasses(e.element, u, d);
          }), !0;
        }
      });
      var f = function f(t, e) {
        if (Array.isArray(t)) return t;
        if (Symbol.iterator in Object(t)) return function sliceIterator(t, e) {
          var n = [],
            o = !0,
            r = !1,
            i = void 0;
          try {
            for (var a, s = t[Symbol.iterator](); !(o = (a = s.next()).done) && (n.push(a.value), !e || n.length !== e); o = !0) {
              ;
            }
          } catch (l) {
            r = !0, i = l;
          } finally {
            try {
              !o && s.return && s.return();
            } finally {
              if (r) throw i;
            }
          }
          return n;
        }(t, e);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      };
      return e.modules.push({
        position: function position(t) {
          var e = t.top,
            n = t.left;
          if (this.options.shift) {
            var o = this.options.shift;
            "function" === typeof this.options.shift && (o = this.options.shift.call(this, {
              top: e,
              left: n
            }));
            var r = void 0,
              i = void 0;
            if ("string" === typeof o) {
              (o = o.split(" "))[1] = o[1] || o[0];
              var a = f(o, 2);
              r = a[0], i = a[1], r = parseFloat(r, 10), i = parseFloat(i, 10);
            } else r = o.top, i = o.left;
            return {
              top: e += r,
              left: n += i
            };
          }
        }
      }), C;
    }) ? o.apply(e, r) : o) || (t.exports = i);
  }, function (t, e, n) {
    var o = n(17);
    "string" === typeof o && (o = [[t.i, o, ""]]);
    var r = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(5)(o, r);
    o.locals && (t.exports = o.locals);
  }, function (t, e, n) {
    (t.exports = n(4)(!1)).push([t.i, "/*\nDEFAULT STYLES FOR TIDE TOOLTIPS\n\nSee the stylesheet in the parent components folder for styles specific to one\nof the default tooltip versions.\n\n1. container styles\n2. tooltip caret placement styles\n3. ribbon banner styles\n\n*/\n\n/* 1. CONTAINER STYLES */\n.tide-tethered-tooltip {\n  padding: 15px;\n  position: relative;\n  opacity: 0;\n  transition: all 0.3s ease;\n}\n\n.tide-tethered-tooltip--open {\n  opacity: 1;\n}\n\n.tide-tethered-tooltip-container {\n  background-color: var(--color-p1-9);\n  box-shadow: 0px 5px 25px 2px rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n  padding: 15px;\n  position: relative;\n  overflow: hidden;\n  max-width: 600px;\n}\n\n.tide-tethered-tooltip-header-row {\n  width: 100%;\n  text-align: right;\n  z-index: 10;\n}\n\n.tide-tethered-tooltip-close-icon {\n  cursor: pointer;\n  color: var(--main-navy-light);\n  opacity: 0.7;\n}\n\n.tide-tethered-tooltip-close-icon:hover {\n  opacity: 1;\n  transition: all 0.3s ease;\n}\n\n.tide-tethered-tooltip-close-icon path {\n  fill: currentColor !important;\n}\n\n.tide-tethered-tooltip-content-horizontal,\n.tide-tethered-tooltip-content-vertical {\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n  -webkit-align-items: center;\n          align-items: center;\n}\n\n.tide-tethered-tooltip-content-horizontal {\n  display: -webkit-flex;\n  display: flex;\n}\n\n.tide-tooltip-content-ribbon-offset {\n  margin-top: 4px;\n}\n\n.tide-tethered-tooltip-copy {\n  color: var(--color-p1-2);\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n}\n\n.tide-tethered-tooltip-header {\n  font-size: 20px;\n  font-family: var(--marketing-font-family--semibold);\n  color: var(--color-p1-2);\n  line-height: 20px;\n}\n\n.tide-tethered-tooltip-copy p {\n  line-height: 20px;\n  margin: 0px;\n}\n\n.tide-tethered-tooltip-button-section {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n  -webkit-align-items: center;\n          align-items: center;\n}\n\n.tide-tethered-tooltip-button {\n  width: 48%;\n  min-width: 120px;\n}\n\n.tide-tethered-tooltip-button-full-width {\n  width: 100% !important;\n}\n\n.tide-tethered-tooltip-button:not(:last-child) {\n  margin-right: 10px;\n}\n\n.tide-tethered-tooltip-media-content-vertical {\n  margin-bottom: 20px;\n}\n\n.tide-tethered-tooltip-media-content img,\n.tide-tethered-tooltip-media-content svg {\n  width: 280px;\n}\n\n.tide-tethered-tooltip-media-content-vertical img {\n  width: 100%;\n}\n\n.tide-tethered-tooltip-close svg,\n.tide-medium-tooltip-close svg {\n  box-sizing: content-box;\n}\n\n/* 2. TOOLTIP CARET PLACEMENT STYLES */\n.tide-tethered-tooltip-caret {\n  position: absolute;\n  height: 30px;\n  width: 30px;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  background-color: var(--color-p1-9);\n  z-index: 5;\n}\n\n.tide-tethered-tooltip-top {\n  bottom: 0;\n}\n\n.tide-tethered-tooltip-right {\n  left: 0;\n}\n\n.tide-tethered-tooltip-bottom {\n  top: 0;\n}\n\n.tide-tethered-tooltip-left {\n  right: 0;\n}\n\n.tide-tethered-tooltip-offset-left {\n  left: 84px;\n}\n.tide-tethered-tooltip-offset-center {\n  left: 48.25%;\n}\n\n.tide-tethered-tooltip-offset-right {\n  right: 84px;\n}\n\n.tide-tethered-tooltip-offset-top {\n  top: 84px;\n}\n\n.tide-tethered-tooltip-offset-middle {\n  top: 46%;\n}\n\n.tide-tethered-tooltip-offset-bottom {\n  bottom: 84px;\n}\n\n/* 3. RIBBON BANNER STYLES */\n.tide-tethered-tooltip-ribbon-banner {\n  position: absolute;\n  color: #fff;\n  top: 15px;\n  left: -21px;\n  width: 90px;\n  -webkit-transform: rotate(315deg) perspective(0);\n          transform: rotate(315deg) perspective(0);\n  text-align: center;\n  height: 20px;\n  line-height: 20px;\n  font-weight: 600;\n  font-size: 0.75rem;\n  z-index: 10;\n}\n\n.tide-tethered-tooltip-ribbon {\n  padding: 4px 4px 2px 4px;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  background-image: linear-gradient(101deg, #ed1886, #8711ff);\n  font-size: 12px;\n  font-family: var(--marketing-font-family--extrabold);\n  letter-spacing: 0.5px;\n  color: var(--color-p1-2);\n  margin-bottom: 4px;\n}\n\n.tide-tethered-tooltip-ribbon-lightning-icon path{\n  fill:yellow;\n}\n\n.tide-tethered-tooltip-ribbon-lightning-icon {\n  position: fixed;\n  margin-top: -14px;\n  margin-left: -7px;\n}\n", ""]);
  }, function (t, e) {
    t.exports = function (t) {
      var e = "undefined" !== typeof window && window.location;
      if (!e) throw new Error("fixUrls requires window.location");
      if (!t || "string" !== typeof t) return t;
      var n = e.protocol + "//" + e.host,
        o = n + e.pathname.replace(/\/[^\/]*$/, "/");
      return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (t, e) {
        var r,
          i = e.trim().replace(/^"(.*)"$/, function (t, e) {
            return e;
          }).replace(/^'(.*)'$/, function (t, e) {
            return e;
          });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i) ? t : (r = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? n + i : o + i.replace(/^\.\//, ""), "url(" + JSON.stringify(r) + ")");
      });
    };
  }, function (t, e, n) {
    var o = n(20);
    "string" === typeof o && (o = [[t.i, o, ""]]);
    var r = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(5)(o, r);
    o.locals && (t.exports = o.locals);
  }, function (t, e, n) {
    (t.exports = n(4)(!1)).push([t.i, "/*\nCUSTOM STLES FOR DEFAULT TOOLTIPS\n\nDefault styles for tooltips live in the component's stylesheet, and these\nstyles help create the list of default exports. Styles include tooltip CSS,\nfollowed by the caret positioning CSS for each size.\n\n1. Large feature tooltip\n2. Medium education tooltip\n3. Small education tooltip\n\n*/\n\n/* 1. LARGE FEATURE TOOLTIP STYLES */\n.tide-large-tooltip {\n  padding: 15px;\n}\n\n.tide-large-tooltip-container-horizontal {\n  padding: 32px;\n  max-width: 640px;\n}\n\n.tide-large-tooltip-container-vertical {\n  padding: 32px;\n  max-width: 280px;\n}\n\n.tide-large-tooltip-header-row {\n  position: absolute;\n  right: 16px;\n  top: 16px;\n  width: auto;\n}\n\n.tide-large-tooltip-copy {\n  max-width: 320px;\n  padding-right: 32px;\n}\n\n.tide-large-tooltip-copy-vertical {\n  max-width: 100%;\n  padding-right: 0;\n}\n\n.tide-large-tooltip-header {\n  padding-bottom: 16px;\n}\n\n.tide-large-tooltip-close svg,\n.tide-medium-tooltip-close svg {\n  box-sizing: content-box;\n}\n\n.tide-large-tooltip-caret {\n  height: 30px;\n  width: 30px;\n}\n\n.tide-large-tooltip-top {\n  bottom: 0;\n}\n\n.tide-large-tooltip-right {\n  left: 0;\n}\n\n.tide-large-tooltip-bottom {\n  top: 0;\n}\n\n.tide-large-tooltip-left {\n  right: 0;\n}\n\n.tide-large-tooltip-offset-left {\n  left: 84px;\n}\n.tide-large-tooltip-offset-center {\n  left: 48.25%;\n}\n\n.tide-large-tooltip-offset-right {\n  right: 84px;\n}\n\n.tide-large-tooltip-offset-top {\n  top: 84px;\n}\n\n.tide-large-tooltip-offset-middle {\n  top: 46%;\n}\n\n.tide-large-tooltip-offset-bottom {\n  bottom: 84px;\n}\n\n.tide-large-tooltip-button-section {\n  margin-top: 24px;\n}\n\n/* 2. MEDIUM EDUCATION TOOLTIP STYLES */\n.tide-medium-tooltip {\n  padding: 15px;\n}\n\n.tide-medium-tooltip--open {\n  opacity: 1;\n}\n\n.tide-medium-tooltip-container {\n  padding: 32px;\n  max-width: 280px;\n}\n\n.tide-medium-tooltip-header-row {\n  position: absolute;\n  right: 32px;\n  top: 32px;\n  width: auto;\n}\n\n.tide-medium-tooltip-header {\n  padding-right: 24px;\n  padding-bottom: 8px;\n}\n\n.tide-medium-tooltip-copy p {\n  margin: 0;\n}\n\n.tide-medium-tooltip-caret {\n  height: 20px;\n  width: 20px;\n}\n\n.tide-medium-tooltip-top {\n  bottom: 5px;\n}\n\n.tide-medium-tooltip-right {\n  left: 10px;\n}\n\n.tide-medium-tooltip-bottom {\n  top: 5px;\n}\n\n.tide-medium-tooltip-left {\n  right: 10px;\n}\n\n.tide-medium-tooltip-offset-left {\n  left: 49px;\n}\n\n.tide-medium-tooltip-offset-center {\n  left: 48.25%;\n}\n\n.tide-medium-tooltip-offset-right {\n  right: 49px;\n}\n\n.tide-medium-tooltip-offset-top {\n  top: 49px;\n}\n\n.tide-medium-tooltip-offset-middle {\n  top: 46%;\n}\n\n.tide-medium-tooltip-offset-bottom {\n  bottom: 49px;\n}\n\n.tide-medium-tooltip-button-section {\n  margin-top: 16px;\n}\n\n/* 3. SMALL EDUCATION TOOLTIP STYLES */\n.tide-small-tooltip {\n  padding: 15px;\n}\n\n.tide-small-tooltip--open {\n  opacity: 1;\n}\n\n.tide-small-tooltip-container {\n  padding: 24px;\n  max-width: 272px;\n}\n\n.tide-small-tooltip-header-row {\n  position: absolute;\n  right: 24px;\n  top: 24px;\n  width: auto;\n}\n\n.tide-small-tooltip-close .tide-small-tooltip-close-icon {\n  padding: 2px;\n}\n\n.tide-small-tooltip-header {\n  padding-right: 24px;\n  padding-bottom: 8px;\n}\n\n.tide-small-tooltip-button-section {\n  display: none;\n}\n\n.tide-small-tooltip-button {\n  width: 30%;\n  min-width: 120px;\n}\n\n.tide-small-tooltip-caret {\n  height: 20px;\n  width: 20px;\n}\n\n.tide-small-tooltip-top {\n  bottom: 10px;\n}\n\n.tide-small-tooltip-right {\n  left: 10px;\n}\n\n.tide-small-tooltip-bottom {\n  top: 10px;\n}\n\n.tide-small-tooltip-left {\n  right: 10px;\n}\n\n.tide-small-tooltip-offset-left {\n  left: 32px;\n}\n\n.tide-small-tooltip-offset-center {\n  left: 48.25%;\n}\n\n.tide-small-tooltip-offset-right {\n  right: 32px;\n}\n\n.tide-small-tooltip-offset-top {\n  top: 32px;\n}\n\n.tide-small-tooltip-offset-middle {\n  top: 46%;\n}\n\n.tide-small-tooltip-offset-bottom {\n  bottom: 32px;\n}\n", ""]);
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var o = n(0),
      r = n.n(o),
      i = "large",
      a = "medium",
      s = "small",
      l = "bottom",
      c = {
        left: "right",
        right: "left",
        top: "bottom",
        bottom: "top"
      },
      p = "center",
      f = "middle",
      d = {
        left: 1,
        center: 2,
        right: 3,
        top: 1,
        middle: 2,
        bottom: 3
      };
    function _defineProperty(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }
    var u = n(2),
      h = n.n(u);
    function asyncGeneratorStep(t, e, n, o, r, i, a) {
      try {
        var s = t[i](a),
          l = s.value;
      } catch (c) {
        return void n(c);
      }
      s.done ? e(l) : Promise.resolve(l).then(o, r);
    }
    function _asyncToGenerator(t) {
      return function () {
        var e = this,
          n = arguments;
        return new Promise(function (o, r) {
          var i = t.apply(e, n);
          function _next(t) {
            asyncGeneratorStep(i, o, r, _next, _throw, "next", t);
          }
          function _throw(t) {
            asyncGeneratorStep(i, o, r, _next, _throw, "throw", t);
          }
          _next(void 0);
        });
      };
    }
    function _defineProperties(t, e) {
      for (var n = 0; n < e.length; n++) {
        var o = e[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
      }
    }
    function _typeof2(t) {
      return (_typeof2 = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof2(t) {
        return typeof t;
      } : function _typeof2(t) {
        return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }
    function _typeof(t) {
      return (_typeof = "function" === typeof Symbol && "symbol" === _typeof2(Symbol.iterator) ? function _typeof(t) {
        return _typeof2(t);
      } : function _typeof(t) {
        return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof2(t);
      })(t);
    }
    function _possibleConstructorReturn(t, e) {
      return !e || "object" !== _typeof(e) && "function" !== typeof e ? function _assertThisInitialized(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }
    function _getPrototypeOf(t) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }
    function _setPrototypeOf(t, e) {
      return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }
    var m = n(1),
      g = n.n(m),
      y = function () {
        var t = _asyncToGenerator(h.a.mark(function _callee(t) {
          return h.a.wrap(function _callee$(e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", new Promise(function (e) {
                    return setTimeout(e, t);
                  }));
                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, _callee);
        }));
        return function pause(e) {
          return t.apply(this, arguments);
        };
      }(),
      v = n(3),
      b = Object.freeze({
        power: "POWER UP",
        new: "NEW!",
        how: "HOW TO",
        upgrade: "UPGRADE",
        getstarted: "GET STARTED"
      }),
      _ = Object.freeze({
        vertical: "vertical",
        horizontal: "horizontal"
      }),
      w = function renderTooltip(t) {
        var e = t.open,
          n = t.ribbonInfo,
          o = t.ribbonType,
          a = t.onClose,
          c = t.headerCopy,
          p = t.bodyCopy,
          d = t.bodyComponent,
          u = t.buttonInfoArray,
          h = t.mediaComponent,
          m = t.tooltipSide,
          y = void 0 === m ? l : m,
          w = t.tooltipCaretLocation,
          x = void 0 === w ? f : w,
          C = t.tooltipType,
          O = t.className,
          T = t.orientation,
          E = void 0 === T ? _.horizontal : T,
          P = C === s;
        return r.a.createElement("div", {
          className: g()(O, "tide-tethered-tooltip", "tide-".concat(C, "-tooltip"), {
            "tide-tethered-tooltip--open": e
          })
        }, r.a.createElement("div", {
          className: g()("tide-tethered-tooltip-caret", "tide-".concat(C, "-tooltip-caret"), "tide-".concat(C, "-tooltip-").concat(y), "tide-".concat(C, "-tooltip-offset-").concat(x))
        }, "\xa0"), r.a.createElement("div", {
          className: g()("tide-tethered-tooltip-container", "tide-".concat(C, "-tooltip-container"), "tide-".concat(C, "-tooltip-container-").concat(E)),
          onClick: function onClick(t) {
            return t.stopPropagation();
          }
        }, n && !P && function renderRibbonBanner(t) {
          var e = t.ribbonCopy,
            n = void 0 === e ? "New!" : e,
            o = t.ribbonColor,
            i = void 0 === o ? "var(--main-violet)" : o;
          return r.a.createElement("div", {
            className: "tide-tethered-tooltip-ribbon-banner",
            style: {
              backgroundColor: i
            }
          }, n);
        }(n), o && !n && E === _.horizontal && r.a.createElement(v.Ribbon, {
          text: b[o] || b.power
        }), r.a.createElement("div", {
          className: g()("tide-tethered-tooltip-header-row", "tide-".concat(C, "-tooltip-header-row"))
        }, r.a.createElement("div", {
          className: g()("tide-tethered-tooltip-close", "tide-".concat(C, "-tooltip-close")),
          onClick: a
        }, r.a.createElement(v.Icon, {
          name: "close",
          width: "14",
          height: "14",
          className: g()("tide-tethered-tooltip-close-icon", "tide-".concat(C, "-tooltip-close-icon"))
        }))), r.a.createElement("div", {
          className: g()("tide-tethered-tooltip-content-".concat(E), "tide-".concat(C, "-tooltip-content"), {
            "tide-tooltip-content-ribbon-offset": n && !P
          })
        }, C === i && E === _.vertical && r.a.createElement("div", {
          className: g()("tide-tethered-tooltip-media-content", "tide-".concat(C, "-tooltip-media-content"), "tide-tethered-tooltip-media-content-vertical")
        }, h), o && !n && E === _.vertical && r.a.createElement(v.Ribbon, {
          text: b[o] || b.power
        }), r.a.createElement("div", {
          className: g()("tide-tethered-tooltip-copy", "tide-".concat(C, "-tooltip-copy"), "tide-".concat(C, "-tooltip-copy-").concat(E))
        }, !!c && r.a.createElement("p", {
          className: g()("tide-tethered-tooltip-header", "tide-".concat(C, "-tooltip-header"))
        }, c), d || r.a.createElement("p", null, p), u && r.a.createElement("div", {
          className: g()("tide-tethered-tooltip-button-section", "tide-".concat(C, "-tooltip-button-section"))
        }, u.map(function (t, e) {
          var n = t.func ? {
            onClick: t.func
          } : {
            href: t.href
          };
          return r.a.createElement(v.Button, Object.assign({
            type: 0 === e ? "primary" : "subtle",
            key: "".concat(C, "-tooltip-button-").concat(e)
          }, n, {
            className: g()("tide-tethered-tooltip-button", "tide-".concat(C, "-tooltip-button"), _defineProperty({}, "tide-tethered-tooltip-button-full-width", u.length < 2 && !P)),
            icon: t.icon
          }), t.copy);
        }))), C === i && E === _.horizontal && r.a.createElement("div", {
          className: g()("tide-tethered-tooltip-media-content", "tide-".concat(C, "-tooltip-media-content"))
        }, h))));
      },
      x = n(6),
      C = n.n(x),
      O = (n(16), function (t) {
        function TetheredToolTip() {
          var t, e;
          !function _classCallCheck(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, TetheredToolTip);
          for (var n = arguments.length, o = new Array(n), r = 0; r < n; r++) {
            o[r] = arguments[r];
          }
          return (e = _possibleConstructorReturn(this, (t = _getPrototypeOf(TetheredToolTip)).call.apply(t, [this].concat(o)))).state = {
            hovering: !1
          }, e.toggleOn = function () {
            e.setState({
              hovering: !0
            }, e.delayOpen);
          }, e.toggleOff = function () {
            e.setState({
              open: !1
            }, e.delayClose);
          }, e.delayClose = _asyncToGenerator(h.a.mark(function _callee() {
            var t, n;
            return h.a.wrap(function _callee$(o) {
              for (;;) {
                switch (o.prev = o.next) {
                  case 0:
                    return t = e.props.delay, n = void 0 === t ? 300 : t, o.next = 3, y(n);
                  case 3:
                    e.setState({
                      hovering: !1
                    });
                  case 4:
                  case "end":
                    return o.stop();
                }
              }
            }, _callee);
          })), e.delayOpen = _asyncToGenerator(h.a.mark(function _callee2() {
            var t, n;
            return h.a.wrap(function _callee2$(o) {
              for (;;) {
                switch (o.prev = o.next) {
                  case 0:
                    return t = e.props.delay, n = void 0 === t ? 300 : t, o.next = 3, y(n);
                  case 3:
                    e.setState({
                      open: !0
                    });
                  case 4:
                  case "end":
                    return o.stop();
                }
              }
            }, _callee2);
          })), e;
        }
        return function _inherits(t, e) {
          if ("function" !== typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && _setPrototypeOf(t, e);
        }(TetheredToolTip, o["Component"]), function _createClass(t, e, n) {
          return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
        }(TetheredToolTip, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.props.showTooltip && this.toggleOn();
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate(t) {
            !t.showTooltip && this.props.showTooltip && this.toggleOn(), t.showTooltip && !this.props.showTooltip && this.toggleOff();
          }
        }, {
          key: "render",
          value: function render() {
            var t,
              e = this.state,
              n = e.hovering,
              o = e.open,
              f = this.props,
              u = f.children,
              h = f.className,
              m = f.tooltipTypeClassName,
              y = f.tooltipCaretLocation,
              v = void 0 === y ? "center" : y,
              b = f.tooltipSide,
              _ = void 0 === b ? "bottom" : b,
              x = f.tooltipType,
              O = void 0 === x ? i : x,
              T = f.event,
              E = void 0 === T ? null : T,
              P = function getTetherPlacement(t) {
                var e,
                  n,
                  o = t.tooltipSide,
                  r = void 0 === o ? l : o,
                  f = t.tooltipCaretLocation,
                  u = void 0 === f ? p : f,
                  h = t.tooltipType,
                  m = void 0 === h ? s : h,
                  g = {},
                  y = c[r],
                  v = d[u],
                  b = m !== s ? "10" : "0",
                  _ = (_defineProperty(e = {}, i, "83"), _defineProperty(e, a, "44"), _defineProperty(e, s, "25"), e),
                  w = (_defineProperty(n = {}, i, "40"), _defineProperty(n, a, "9"), _defineProperty(n, s, "-9"), n);
                switch (r) {
                  case "top":
                    g.attachment = "".concat(y, " ").concat(u), g.targetAttachment = "".concat(r, " ").concat(u), g.offset = "".concat(b, "px 0"), g.targetOffset = "0px ".concat((v - 2) * w[m], "%");
                    break;
                  case "left":
                    g.attachment = "".concat(u, " ").concat(y), g.targetAttachment = "".concat(u, " ").concat(r), g.offset = "0px ".concat(b, "px"), g.targetOffset = "".concat((v - 2) * _[m], "px 0px");
                    break;
                  case "right":
                    g.attachment = "".concat(u, " ").concat(y), g.targetAttachment = "".concat(u, " ").concat(r), g.offset = "0px -".concat(b, "px"), g.targetOffset = "".concat((v - 2) * _[m], "px 0px");
                    break;
                  default:
                    g.attachment = "".concat(y, " ").concat(u), g.targetAttachment = "".concat(r, " ").concat(u), g.offset = "-".concat(b, "px 0%"), g.targetOffset = "0px ".concat((v - 2) * w[m], "%");
                }
                return g;
              }({
                tooltipCaretLocation: v,
                tooltipSide: _,
                tooltipType: O
              }),
              S = E ? {
                onMouseOver: this.toggleOn,
                onMouseOut: this.toggleOff
              } : {};
            return r.a.createElement("div", S, r.a.createElement(C.a, Object.assign({}, P, {
              className: g()((t = {}, _defineProperty(t, h, !!h), _defineProperty(t, m, !!m), t))
            }), u, n && w(function _objectSpread(t) {
              for (var e = 1; e < arguments.length; e++) {
                var n = null != arguments[e] ? arguments[e] : {},
                  o = Object.keys(n);
                "function" === typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(n).filter(function (t) {
                  return Object.getOwnPropertyDescriptor(n, t).enumerable;
                }))), o.forEach(function (e) {
                  _defineProperty(t, e, n[e]);
                });
              }
              return t;
            }({}, this.props, {
              open: o,
              tooltipType: O,
              className: h
            }))));
          }
        }]), TetheredToolTip;
      }());
    n(19);
    n.d(e, "EducationTooltip", function () {
      return T;
    }), n.d(e, "SmallEducationTooltip", function () {
      return E;
    }), n.d(e, "FeatureTooltip", function () {
      return P;
    }), n.d(e, "TetheredTooltip", function () {
      return S;
    });
    var T = function EducationTooltip(t) {
        return r.a.createElement(O, Object.assign({}, t, {
          tooltipType: a
        }));
      },
      E = function SmallEducationTooltip(t) {
        return r.a.createElement(O, Object.assign({}, t, {
          tooltipType: s
        }));
      },
      P = function FeatureTooltip(t) {
        return r.a.createElement(O, Object.assign({}, t, {
          tooltipType: i
        }));
      },
      S = O;
  }]);
});